import React from "react"
import first from "./1.jpg"

import Box from "@material-ui/core/Box"
import Faq from "react-faq-component"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    
    faInstagram
  
    
 } from "@fortawesome/free-brands-svg-icons"
import three from "./image1.jpg"
function Page(){
    const data = {
        title : "Frequently asked questions",
        rows : [
        {
        title: "Do you store personal Information",
        content: `No, we does not share any personal info.`,
        },
        {
        title: "Will you do Freelancing?",
        content: 'Yes, I am ready to take opportunities.',
        },
        {
        title: "Which FrontEnd languages you are comfortable in?",
        content: `HTML 5, CSS3, JavaScript, React..etc.`,
        },
        {
        title: "Do you have any experience?",
        content: `I hae little experience in couple of projects as Web Developer.`,
        },
        
        ]
        }
        const config = {
        //animate: true,
        arrowIcon: "+",
        tabFocus: true
       };
      const styles = {
     
        titleTextColor: '#171616',
      titleTextSize : '20px',
     rowTitleColor: '#171616',
       rowContentColor: '#8A8A8A',
   rowContentTextSize: '16px',
       rowPaddingLeft : '10px', 
     rowContentPaddingRight: '50px',
        rowContentPaddingBottom: '30px',
    transitionDuration: "1s",
     
       fontWeight: 700,
       backgroundColor: '#eedd82'
        
      }
  
    return (
      <div style={{justifyContent: 'center'}}>
       
        <div style={{backgroundColor: '#8fc4ec', justifyContent: 'center'}}>
        
          <h1 style={{textAlign: 'center', color: '#c38d9e', paddingTop: '2%'}}>Welcome to Creative Programmers Life</h1>
          <br/>
          <img  style={{width: '100%',textAlign: 'center', justifyContent: 'center'}} src={first} /> 
        </div>
        <div style={{justifyContent: 'center', width: '30%', textAlign: 'center', marginLeft: '40%', marginTop: '5%', marginRight:'40%'}} >
            <h2>Projects</h2>
          <Box color="white" bgcolor="black" p={1} style={{justifyContent: 'center', cursor: 'pointer', marginTop: '5%', textAlign: "center"}} >
          <a style={{textDecoration: 'none', color: 'white'}} href="https://creativeprogrammerslifemotivationapp.netlify.app/">Inspirational Quote App</a>
          </Box>
          <Box color="white" bgcolor="black" p={1} style={{justifyContent: 'center', cursor: 'pointer', marginTop: '5%'}} >
          <a style={{textDecoration: 'none', color: 'white'}} href="https://creativeprogrammerslifetodoapp.netlify.app">ToDo App</a>
          </Box>
          
        </div>
        <div style={{marginLeft: '20%', marginRight: '20%', marginTop: '5%', backgroundColor: '#eedd82'}}>
        <Faq 
 bordered={false}
 config = {config} 
 data = {data}
 styles = {styles}
 />
        </div>
        <div style={{justifyContent: 'center', backgroundColor: '#eedd82', marginTop: '7%', textAlign: 'center'}}>
            <br/>
            <text style={{color: 'white', textAlign: 'center', justifyContent: 'center', fontSize: 50}}>Follow us on </text><a  href="https://www.instagram.com/creative_programmers_life/" style={{marginLeft: '5%'}}><FontAwesomeIcon icon={faInstagram} size="4x" style={{objectFit: 'contain', color: '#c13f84'}} /></a>

        </div>
      </div>
    )

}
export default Page